import { BannerCarousel } from '@/views/WatchLandingView/BannerCarousel'
import { RecommendedBannerCarousel } from '@/views/WatchLandingView/RecommendedBannerCarousel'
import { useWatchPageContext } from '@/views/WatchLandingView/WatchPageContext'

export interface BannerCarouselProps {
  groupId: string
  preview?: boolean
}

export const BannerCarouselWrapper: React.FC<BannerCarouselProps> = (props) => {
  const { shouldUseBannerService } = useWatchPageContext()

  if (shouldUseBannerService) {
    return <RecommendedBannerCarousel />
  } else {
    return <BannerCarousel {...props} />
  }
}
